import { useEffect, useState } from 'react';

/**
 * สถานะการเชื่อมต่อของเครื่องสแกน
 *
 * `navigator.onLine` บอกได้แค่ว่ามี network interface หรือไม่ ไม่ได้ยืนยันว่า
 * API ตอบจริง — หน้าจอจึงต้องพูดว่า "ออนไลน์" ในความหมายของอุปกรณ์เท่านั้น
 * และห้ามใช้ค่านี้ตัดสินว่าธุรกรรม post สำเร็จ (docs/SECURITY.md — Offline Policy)
 */
export function useConnectivity(): boolean {
  const [online, setOnline] = useState<boolean>(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine,
  );

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const goOnline = () => {
      setOnline(true);
    };
    const goOffline = () => {
      setOnline(false);
    };
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    setOnline(navigator.onLine);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return online;
}
